
(($) => {
  Drupal.behaviors.panels = {
    attach(context) {

      // console.log(context);
      // console.log($().jquery); // 3.6.0

      // Otevreni podle hashe
      function initOpenByHash(context) {

        // deconstruction https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Destructuring_assignment
        const { hash } = window.location;
        if (hash) {
          const $hashLinkSelector = $(`.panel.panel--closed a.panel__link[href="${hash}"]`, context);
          $hashLinkSelector.each(function() {
            const $panel = $(this).closest('.panel');
            $panel.removeClass('panel--closed').addClass('panel--open');
            $panel.find('.panel__content').show();
          });
        }

      }

      // pocatecni viditelnost se musi predelat z css trid primo na styl, aby sel slideDown a slideUp
      function initVisibility(context) {

        // pres vsechny existujici panely
        $('.panel', context).each(function() {

          const $panel = $(this);
  
          const $content = $panel.find('.panel__content');

          if ($panel.hasClass('panel--closed')) {
            $content.hide();
            $panel.removeClass('panel--closed');      
          }

          if ($panel.hasClass('panel--open')) {
            $content.show();
            $panel.removeClass('panel--open');
          }

        });

      }


      // Handler na click
      function initHandler(context) {
  
        // click - rozbaleni / sbaleni panelu
        $('.panel .panel__header', context).on('click', (function (e) {
          
            e.preventDefault();

            const $panel = $(this).closest('.panel');
            const $content = $panel.find('.panel__content');
            
            const $link = $panel.find('.panel__link');
            const hash = $link.attr('href');

            window.location.hash = hash;

            $content.slideToggle('fast');

        
          }));

          $(document).on('click', '.panel__content a', function (e) {
            const href = $(this).attr('href');
            const hashMatch = href.match(/#panel_\d+/);
            const hash = hashMatch ? hashMatch[0] : null;

            if (hash) {
              e.preventDefault();
              const $targetHeader = $(hash);
              if ($targetHeader.length > 0) {
                const $targetPanel = $targetHeader.closest('.panel');
                const $content = $targetPanel.find('.panel__content');
                if ($content.is(':hidden')) {
                  $content.slideDown('fast');
                }
                $('html, body').animate({ scrollTop: $targetPanel.offset().top - 60 }, 500);
              }
            }
          });
        }

      // kontrola na zamek
      // 1. kontrola nastaveni globalni promenne
      // 2. existence elementu v ramci contextu
      if (window.upce_panel_init || $(context).find('.panel').length === 0) {
        return false;
      }

      // musi se vola 1., respektrive pred initVisibility
      initOpenByHash(context);

      initVisibility(context);
  
      initHandler(context);

      // zamek ON
      window.upce_panel_init = true;

    },
  };
})(jQuery);

